import { FormDataPersonalInformation } from ".";
import { emptyValues as emptyValuesPerson } from "../FormPartialPerson/emptyValues";

export const emptyValues: FormDataPersonalInformation = {
  person: emptyValuesPerson
};
